export enum RentTab {
  AvailableHouses = 'available-houses',
  StakedHouses = 'staked-houses',
  Market = 'market'
}

export enum FilterCondition {
  Good = 'rentFilter_condition_good',
  NeedsRepair = 'rentFilter_condition_needsRepair'
}

export enum FilterType {
  Wooden = 'wooden',
  Brick = 'stone',
  TiledBrick = 'tiledBrick'
}

export interface IFilterState {
  condition: FilterCondition[];
  type: FilterType[];
}
